import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import { showModal, hideModal } from '../../../actions/modal';
import EmailOtpVerify from '../../pages/Account/EmailOTP/EmailOtpVerfiy';
import Dialog from '../../molecules/Dialog';
import Modal from '../../../components/common/Modal';
import Text from '../Text';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';

const cx = classNames.bind(styles);

interface VerifyCustomerPropsType {
  isDesktop: boolean;
  showModal: any;
  closeModal: any;
  ctaLabel: string;
}

const VerifyCustomer = (props: VerifyCustomerPropsType) => {
  const { isDesktop = true, showModal, closeModal, ctaLabel } = props;
  const [visibility, setVisibility] = useState(false);
  const openOtpModal = () => {
    if (isDesktop) {
      showModal('email-otp-popup');
    } else {
      setVisibility(true);
    }
    gtmEventPush({
      event: 'buttonTap',
      event_category: 'buttonTap',
      event_action: 'verify email click',
      event_label: 'my account screen',
      screen_name: 'my account screen'
    });

   
  };
  const hideDialog = () => {
    sessionStorage.removeItem('modal');
    setVisibility(false);
  };
  return (
    <div
      className={cx(
        'ril-email-verify-section',
        isDesktop ? 'desk-verify-customer' : 'mobile-verify-customer'
      )}
      style={{ border: !isDesktop ? 'solid 1.5px #fff' : '' }}
    >
      <div className={cx('warning-sign')} style={{ float: 'left' }} />
      <div className={cx('ril-email-verify-content', isDesktop ? 'desktop-content' : '')}>
        <div className={cx('ril-email-verify-text')}>
          <Text variant="T2" color="Nero">
            {ctaLabel}
          </Text>
        </div>
        <div
          className={cx('verify-now-btn', isDesktop ? 'desk-ril-verify-btn' : 'mob-ril-verify-btn')}
          onClick={openOtpModal}
          style={isDesktop ? {} : {
            paddingTop:'20px',
            marginTop:'-10px'
          }}
        >
          <Text
            variant="T2"
            weight="bold"
            customClass={isDesktop ? cx('desk-verify-txt-color') : cx('mob-verify-txt-color')}
          >
            Verify email now
          </Text>
        </div>
      </div>
      <Dialog showDialog={visibility} type="drawer" onCancel={hideDialog}>
        {visibility && <EmailOtpVerify deviceType="MSITE" hideDialog={hideDialog} />}
      </Dialog>
      <Modal
        name="email-otp-popup"
        className="user-profile-otp-mob"
        disableOutsideClick={false}
        redirect={false}
        closeButton
        onClose={closeModal}
      >
        <EmailOtpVerify />
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    showModal: (name: any, config: any) => {
      dispatch(showModal(name, config));
    },
    closeModal: (name: string) => dispatch(hideModal(name))
  };
};
export default connect(null, mapDispatchToProps)(VerifyCustomer);
